/* PV kit contents (W4): show the kit items for the selected lid system.
   Inputs, in order of reliability:
   1. Dawn pub/sub PUB_SUB_EVENTS.variantChange (product-info.js publishes { data: { variant } }).
   2. `change` on the product form's hidden input[name="id"] (Dawn dispatches it on every variant change).
   3. ?variant= in the URL on first load (server already renders the right list; this covers cached HTML).
   The map { variantId: 'valved' | 'plain' | 'all' } is rendered by Liquid inside the element. */
if (!customElements.get('pv-kit-contents')) {
  customElements.define(
    'pv-kit-contents',
    class PvKitContents extends HTMLElement {
      connectedCallback() {
        const mapEl = this.querySelector('[data-pv-kit-map]');
        if (!mapEl) return;
        try {
          this.map = JSON.parse(mapEl.textContent);
        } catch (e) {
          return;
        }

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const variant = event && event.data && event.data.variant;
            if (variant && variant.id) this.apply(variant.id);
          });
        }

        this.onChange = (event) => {
          const target = event.target;
          if (target && target.name === 'id' && target.closest('form[data-type="add-to-cart-form"]')) {
            this.apply(target.value);
          }
        };
        document.addEventListener('change', this.onChange);

        const fromUrl = new URLSearchParams(window.location.search).get('variant');
        if (fromUrl) this.apply(fromUrl);
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
        if (this.onChange) document.removeEventListener('change', this.onChange);
      }

      apply(variantId) {
        const mode = this.map[String(variantId)];
        if (!mode || mode === this.dataset.mode) return;
        this.dataset.mode = mode;

        this.querySelectorAll('[data-pv-kit-for]').forEach((item) => {
          const target = item.dataset.pvKitFor;
          item.hidden = !(mode === 'all' || target === 'all' || target === mode);
        });

        const showing = this.querySelector('[data-pv-kit-showing]');
        if (showing) {
          showing.hidden = mode === 'all';
          showing.querySelectorAll('[data-pv-kit-label]').forEach((label) => {
            label.hidden = label.dataset.pvKitLabel !== mode;
          });
        }
      }
    }
  );
}
